import { useEffect } from "react";

const SITE_URL = "https://www.dorothyreadhealing.com";

function setMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const match = selector.match(/\[(name|property)="(.+?)"\]/);
    if (match) el.setAttribute(match[1], match[2]);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, path }) {
  useEffect(() => {
    document.title = title;
    const url = `${SITE_URL}${path}`;
    setMeta('meta[name="description"]', { content: description });
    setMeta('meta[property="og:title"]', { content: title });
    setMeta('meta[property="og:description"]', { content: description });
    setMeta('meta[property="og:url"]', { content: url });
    setMeta('meta[name="twitter:title"]', { content: title });
    setMeta('meta[name="twitter:description"]', { content: description });
    setCanonical(url);
  }, [title, description, path]);
  return null;
}
